export default ({
  to,
}) => ({
  componentName: 'cell-affiliates',
  componentArgs: {
    to,
  },
});
